import { Box } from '@nimbus-ds/components';
import { PaginationStratus } from 'commons/components';
import TransferListTable from './TransferListTable';
import { useTransfersDesktop } from '../../hooks';
import { TransferListPage } from '../components';

function TransferListDesktopPage() {
  const {
    pagination,
    changePage,
    data,
    isDataEmpty,
    isError,
    isLoading,
    refetch,
  } = useTransfersDesktop();

  return (
    <TransferListPage
      skeleton={<TransferListTable.Skeleton />}
      isLoading={isLoading}
      isEmpty={isDataEmpty}
      isError={isError}
      onRetry={refetch}
    >
      <Box flexDirection="column" gap="2" display="flex">
        <TransferListTable data={data} />
        <PaginationStratus
          currentPage={pagination.currentPage}
          totalItems={pagination.totalResults}
          itemName="items"
          page={pagination.currentPage}
          perPage={pagination.perPage}
          onPageSelect={changePage}
        />
      </Box>
    </TransferListPage>
  );
}

export default TransferListDesktopPage;
